// extracted by mini-css-extract-plugin
export default {"main":"fAQ_main__uPI6S","accordion":"fAQ_accordion__BgIOV","faqheading":"fAQ_faqheading__sBkLb","faqsubheading":"fAQ_faqsubheading__08RvV"};